import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16258590")

_pushScopeId("data-v-16258590")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "group" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_5 = { class: "text add" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.entities, (entity) => {
        return (_openBlock(), _createBlock("div", {
          class: ["platform", entity.class],
          key: entity
        }, [
          _createVNode("label", {
            for: _ctx.name + '-' + entity.label,
            class: "label-checkbox"
          }, [
            _createVNode("input", {
              onChange: ($event: any) => (_ctx.addLanguage(entity.label)),
              type: "checkbox",
              id: _ctx.name + '-' + entity.label,
              name: _ctx.name,
              checked: _ctx.selectedLanguages.includes(entity.label)
            }, null, 40, ["onChange", "id", "name", "checked"]),
            _hoisted_4
          ], 8, ["for"]),
          _createVNode("span", _hoisted_5, _toDisplayString(entity.title), 1)
        ], 2))
      }), 128))
    ])
  ]))
})